module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pendencyBody"
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n                ")], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.name))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User Filter")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "addedUserFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "userFilter", $$v)
      },
      expression: "Filter.userFilter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(!_vm.isLoading) ? _c('small', [_vm._v(_vm._s(_vm.JOBList.length) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [(_vm.JOBList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName !== 'Export As Excel',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.ExcelBtnName) + "\n                        "), (_vm.ExcelBtnName !== 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.JOBList.length,
      "per-page": _vm.paginationItem.perPage
    },
    model: {
      value: (_vm.paginationItem.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.paginationItem, "currentPage", $$v)
      },
      expression: "paginationItem.currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row table-wrapper-scroll-x my-custom-scrollbar"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnMain,
      "items": _vm.JOBList,
      "per-page": _vm.paginationItem.perPage,
      "current-page": _vm.paginationItem.currentPage,
      "filter": _vm.filter
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                            " + _vm._s(row0.index + 1) + "\n                        ")])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-058bb46c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/containerDash/FailedPrealertList.vue
// module id = 2359
// module chunks = 0